/** @file Applies a client→server id remap to the selection and the playhead animation. */
import type { Id } from '@pose2d/format/types';
import { playheadStore } from '../../stores/playheadStore';
import { selectionStore } from '../../stores/selectionStore';
import { remapIds } from './remapIds';

/** Rewrites selected bones, slots, vertices and keys and the playhead animation (no-op for an empty map). */
export function remapSelection(map: ReadonlyMap<Id, Id>): void {
  if (map.size === 0) return;
  selectionStore.setState(remapIds.apply(selectionStore.getState(), map));
  const { animation } = playheadStore.getState();
  if (animation !== null) playheadStore.setState({ animation: map.get(animation) ?? animation });
}
